import * as React from "react";

import { cn } from "~/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  helperText?: string;
  withCurrency?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, helperText, withCurrency, ...props }, ref) => {
    const isEmpty = !props.value && props.placeholder;

    const input = (
      <input
        type={type}
        className={cn(
          "peer flex h-12 md:h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          withCurrency && "pl-5",
          className
        )}
        ref={ref}
        {...props}
      />
    );

    const wrappedInput = withCurrency ? (
      <div className="relative flex items-center">
        <span
          className={cn(
            "absolute left-3 text-sm",
            isEmpty ? "text-muted-foreground" : "text-foreground"
          )}
        >
          $
        </span>
        {input}
      </div>
    ) : (
      input
    );

    if (helperText) {
      return (
        <fieldset className="flex flex-col gap-2">
          {wrappedInput}
          <p className="text-xs">{helperText}</p>
        </fieldset>
      );
    }

    return wrappedInput;
  }
);

Input.displayName = "Input";
